import { render, staticRenderFns } from "./CheckGovernment.vue?vue&type=template&id=721d3881&scoped=true&"
import script from "./CheckGovernment.vue?vue&type=script&lang=js&"
export * from "./CheckGovernment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721d3881",
  null
  
)

export default component.exports